export const translations = {
  es: {
    // Nav
    nav_home: "Inicio",
    nav_support: "Soporte",
    nav_privacy: "Privacidad",
    nav_terms: "Términos",
    nav_download: "Descargar App",

    // Hero
    hero_headline: "Entrena con propósito.",
    hero_headline_accent: "Progreso real.",
    hero_subhead: "Coaching de fuerza con 14 años de experiencia. Programas, técnica, nutrición y soporte directo — desde tu iPhone.",
    hero_cta: "Descargar en App Store",
    hero_cta_secondary: "Ver cómo funciona",

    // Features
    features_title: "Todo lo que necesitas",
    features_subtitle: "Un ecosistema completo para tu entrenamiento, accesible desde tu iPhone.",
    feature_1_title: "Reserva sesiones",
    feature_1_desc: "Agenda entrenamientos presenciales directamente desde la app.",
    feature_2_title: "Videoconsultas",
    feature_2_desc: "Sesiones de coaching en vivo desde cualquier lugar.",
    feature_3_title: "Vídeos de técnica",
    feature_3_desc: "Biblioteca de ejercicios con demostración detallada.",
    feature_4_title: "Programas de entrenamiento",
    feature_4_desc: "Planes personalizados adaptados a tus objetivos.",
    feature_5_title: "Planes de nutrición",
    feature_5_desc: "Guía alimentaria diseñada para maximizar tus resultados.",
    feature_6_title: "Chat directo",
    feature_6_desc: "Comunicación directa con Anyelo para resolver tus dudas.",

    // How it works
    how_title: "Cómo funciona",
    how_subtitle: "Tres pasos para empezar tu transformación.",
    how_step_1_title: "Descarga la app",
    how_step_1_desc: "Disponible en App Store para iPhone.",
    how_step_2_title: "Elige tu plan",
    how_step_2_desc: "Sesiones individuales, packs de 5 o 10, o suscripción mensual.",
    how_step_3_title: "Entrena con guía",
    how_step_3_desc: "Seguimiento personalizado y soporte continuo.",

    // Bio / Trust
    bio_title: "Sobre Anyelo",
    bio_text: "Con más de 14 años de experiencia en entrenamiento de fuerza, Anyelo ha ayudado a cientos de clientes a alcanzar sus objetivos. Su método combina ciencia del ejercicio, nutrición basada en evidencia y un acompañamiento cercano para garantizar resultados reales y sostenibles.",
    bio_experience: "14+ años de experiencia",
    bio_method: "Método basado en evidencia",
    bio_results: "Resultados comprobados",

    // Final CTA
    final_cta_title: "¿Listo para empezar?",
    final_cta_text: "Descarga Anyelo Elite y comienza tu transformación hoy.",
    final_cta_button: "Descargar en App Store",
    download_note: "Disponible en iOS y Android. Escanea el código QR o toca un botón para descargar.",
    download_scan: "Escanea para descargar",

    // Support page
    support_title: "Centro de soporte",
    support_subtitle: "Encuentra respuestas a las preguntas más frecuentes o contáctanos directamente.",
    support_faq_title: "Preguntas frecuentes",
    support_contact_title: "¿Necesitas más ayuda?",
    support_contact_text: "Envíanos un mensaje y te responderemos lo antes posible.",
    support_email_label: "O escríbenos directamente a:",

    // FAQ items
    faq_1_q: "¿Cómo creo mi cuenta?",
    faq_1_a: "Descarga la app desde App Store, ábrela y sigue el proceso de registro con tu email. Recibirás un correo de confirmación.",
    faq_2_q: "¿Cómo reservo una sesión de entrenamiento?",
    faq_2_a: "Desde la pantalla principal, selecciona 'Reservar sesión', elige la fecha y hora disponible, y confirma tu reserva. Necesitas tener sesiones disponibles en tu pack.",
    faq_3_q: "¿Cómo funcionan las videoconsultas?",
    faq_3_a: "Las videoconsultas se realizan directamente dentro de la app. Una vez reservada, recibirás una notificación antes de la sesión con el enlace para conectarte.",
    faq_4_q: "¿Qué planes de pago hay disponibles?",
    faq_4_a: "Ofrecemos sesiones individuales, packs de 5 y 10 sesiones, y una suscripción mensual con acceso ilimitado. Todos los pagos se procesan de forma segura a través de Stripe.",
    faq_5_q: "¿Puedo cancelar una sesión reservada?",
    faq_5_a: "Sí, puedes cancelar con al menos 24 horas de antelación desde la sección 'Mis reservas'. Las cancelaciones tardías no son reembolsables.",
    faq_6_q: "¿Qué hago si tengo problemas técnicos?",
    faq_6_a: "Primero asegúrate de tener la última versión de la app. Si el problema persiste, contacta con nuestro soporte a través del formulario de esta página o envíanos un email.",
    faq_7_q: "¿Cómo puedo cancelar mi suscripción?",
    faq_7_a: "Las suscripciones se gestionan a través de tu cuenta de Apple. Ve a Ajustes > Tu ID de Apple > Suscripciones y selecciona Anyelo Elite para cancelar.",

    // Contact form
    contact_name: "Nombre",
    contact_email: "Email",
    contact_subject: "Asunto",
    contact_message: "Mensaje",
    contact_submit: "Enviar mensaje",
    contact_sending: "Enviando...",
    contact_success: "¡Mensaje enviado! Te responderemos pronto.",
    contact_error: "No se pudo enviar. Inténtalo de nuevo.",
    contact_name_placeholder: "Tu nombre",
    contact_email_placeholder: "tu@email.com",
    contact_subject_placeholder: "¿En qué podemos ayudarte?",
    contact_message_placeholder: "Describe tu consulta...",

    // Privacy
    privacy_title: "Política de Privacidad",
    privacy_updated: "Última actualización",

    // Terms
    terms_title: "Términos de Servicio",
    terms_updated: "Última actualización",

    // Footer
    footer_tagline: "Entrenamiento de fuerza con método y seguimiento personalizado.",
    footer_links: "Enlaces",
    footer_legal: "Legal",
    footer_contact: "Contacto",
    footer_rights: "Todos los derechos reservados.",
  },
  en: {
    // Nav
    nav_home: "Home",
    nav_support: "Support",
    nav_privacy: "Privacy",
    nav_terms: "Terms",
    nav_download: "Download App",

    // Hero
    hero_headline: "Train with purpose.",
    hero_headline_accent: "Real progress.",
    hero_subhead: "Strength coaching with 14 years of experience. Programs, technique, nutrition and direct support — from your iPhone.",
    hero_cta: "Download on App Store",
    hero_cta_secondary: "See how it works",

    // Features
    features_title: "Everything you need",
    features_subtitle: "A complete training ecosystem, accessible from your iPhone.",
    feature_1_title: "Book sessions",
    feature_1_desc: "Schedule in-person training sessions directly from the app.",
    feature_2_title: "Video consultations",
    feature_2_desc: "Live coaching sessions from anywhere.",
    feature_3_title: "Technique videos",
    feature_3_desc: "Exercise library with detailed demonstrations.",
    feature_4_title: "Training programs",
    feature_4_desc: "Personalized plans adapted to your goals.",
    feature_5_title: "Nutrition plans",
    feature_5_desc: "Dietary guidance designed to maximize your results.",
    feature_6_title: "Direct chat",
    feature_6_desc: "Direct communication with Anyelo to resolve your questions.",

    // How it works
    how_title: "How it works",
    how_subtitle: "Three steps to start your transformation.",
    how_step_1_title: "Download the app",
    how_step_1_desc: "Available on the App Store for iPhone.",
    how_step_2_title: "Choose your plan",
    how_step_2_desc: "Individual sessions, packs of 5 or 10, or monthly subscription.",
    how_step_3_title: "Train with guidance",
    how_step_3_desc: "Personalized tracking and continuous support.",

    // Bio / Trust
    bio_title: "About Anyelo",
    bio_text: "With over 14 years of experience in strength training, Anyelo has helped hundreds of clients achieve their goals. His method combines exercise science, evidence-based nutrition, and close guidance to ensure real, sustainable results.",
    bio_experience: "14+ years of experience",
    bio_method: "Evidence-based method",
    bio_results: "Proven results",

    // Final CTA
    final_cta_title: "Ready to start?",
    final_cta_text: "Download Anyelo Elite and begin your transformation today.",
    final_cta_button: "Download on App Store",
    download_note: "Available on iOS and Android. Scan the QR code or tap a badge to download.",
    download_scan: "Scan to download",

    // Support page
    support_title: "Support Center",
    support_subtitle: "Find answers to frequently asked questions or contact us directly.",
    support_faq_title: "Frequently Asked Questions",
    support_contact_title: "Need more help?",
    support_contact_text: "Send us a message and we'll get back to you as soon as possible.",
    support_email_label: "Or email us directly at:",

    // FAQ items
    faq_1_q: "How do I create my account?",
    faq_1_a: "Download the app from App Store, open it and follow the registration process with your email. You'll receive a confirmation email.",
    faq_2_q: "How do I book a training session?",
    faq_2_a: "From the main screen, select 'Book session', choose an available date and time, and confirm your booking. You need available sessions in your pack.",
    faq_3_q: "How do video consultations work?",
    faq_3_a: "Video consultations take place directly within the app. Once booked, you'll receive a notification before the session with the link to connect.",
    faq_4_q: "What payment plans are available?",
    faq_4_a: "We offer individual sessions, packs of 5 and 10 sessions, and a monthly subscription with unlimited access. All payments are securely processed through Stripe.",
    faq_5_q: "Can I cancel a booked session?",
    faq_5_a: "Yes, you can cancel at least 24 hours in advance from the 'My bookings' section. Late cancellations are non-refundable.",
    faq_6_q: "What should I do if I have technical issues?",
    faq_6_a: "First make sure you have the latest version of the app. If the problem persists, contact our support through the form on this page or send us an email.",
    faq_7_q: "How can I cancel my subscription?",
    faq_7_a: "Subscriptions are managed through your Apple account. Go to Settings > Your Apple ID > Subscriptions and select Anyelo Elite to cancel.",

    // Contact form
    contact_name: "Name",
    contact_email: "Email",
    contact_subject: "Subject",
    contact_message: "Message",
    contact_submit: "Send message",
    contact_sending: "Sending...",
    contact_success: "Message sent! We'll get back to you soon.",
    contact_error: "Could not send. Please try again.",
    contact_name_placeholder: "Your name",
    contact_email_placeholder: "your@email.com",
    contact_subject_placeholder: "How can we help?",
    contact_message_placeholder: "Describe your inquiry...",

    // Privacy
    privacy_title: "Privacy Policy",
    privacy_updated: "Last updated",

    // Terms
    terms_title: "Terms of Service",
    terms_updated: "Last updated",

    // Footer
    footer_tagline: "Strength training with method and personalized guidance.",
    footer_links: "Links",
    footer_legal: "Legal",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",
  }
};
